import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import "../../style/adminreport.css";
import "../../style/reportdentist1.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { apiAxios } from "../../utils/apiAxios";
import { OrderDropdownItem } from "../CentralHub/Admin/Interfaces/OrderDropdownItem";
import { OrderTypeDropdownItem } from "../CentralHub/Admin/Interfaces/OrderTypeDropdownItem";
const API_BASE = process.env.REACT_APP_API_BASE_URL;


interface OrderRow {
  orderId: number;
  clinic: string;
  type: string;
  assignedHub: string;
  assignedDesigner: string;
  partner: string;
  paymentType: string;
  paymentStatus: string;
  expectedDelivery: string;
  phone: string;
  payment: number;
  status: string;
}


const DentistReport = () => {
  const [orderDropdown, setOrderDropdown] = useState<OrderDropdownItem[]>([]);
  const [orderTypeDropdown, setOrderTypeDropdown] = useState<OrderTypeDropdownItem[]>([]);
  const [tableData, setTableData] = useState<OrderRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [filters, setFilters] = useState({
    orderId: "",
    clinic: "",
    type: "",
    hub: "",
    designer: "",
    partner: "",
    paymentType: "",
    paymentStatus: "",
    fromDate: "",
    toDate: "",
  });

 

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    setFilters({
      orderId: "",
      clinic: "",
      type: "",
      hub: "",
      designer: "",
      partner: "",
      paymentType: "",
      paymentStatus: "",
      fromDate: "",
      toDate: "",
    });

    setSearch("");
    setStartDate(null); 
    setEndDate(null);
    setTableData([]);
  };


  const fetchReport = async () => {
    try {
      setLoading(true);

      const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");

      const payload = {
        clinicId: selectedClinic.clinicID,
        orderId: filters.orderId,
         orderTypeID: filters.type ? Number(filters.type) : null,
        //orderType: filters.type,
        fromDate: startDate,
        toDate: endDate,
        search: search
      };

      const res = await apiAxios.post(`${API_BASE}/DentistReport/get-report`, payload);
      if (res.data.isSuccess) {
        const mapped = (res.data.data || []).map((item: any) => ({
          orderId: item.orderID,
          clinic: item.clinicName || "",
          type: item.orderTypeName || "",
          status: (item.currentOrderState || "").toUpperCase()
        }));

        setTableData(mapped);

      }

    } catch (err) {
      console.error("Search API error:", err);
    } finally {
      setLoading(false);
    }
  };
  const filteredData = tableData;
  const totalOrders = filteredData.length;
  const totalRevenue = filteredData.reduce(
    (a, b) => a + b.payment,
    0
  );

 const completedOrders = filteredData.filter((x) => {
  const status = (x.status || "").toLowerCase().trim();

  return (
    status === "delivered" ||
    status === "completed(design)"
  );
}).length;
  const pendingOrders = filteredData.filter((x) => {
    const status = (x.status || "").toLowerCase().trim();

    return (
      status !== "delivered" &&
      status !== "completed" &&
      status !== "completed(design)" &&
      status !== "cancelled" &&
      status !== "cancellation_under_review" &&
      status !== "cancellation under review"
    );
  }).length;

  const cancelledOrders = filteredData.filter((x) => {
    const status = (x.status || "").toLowerCase().trim();

    return (
      status === "cancelled" ||
      status === "cancellation_under_review" ||
      status === "cancellation under review"
    );
  }).length;

  const columns = useMemo(
    () => [
      {
        name: "Order ID",
        selector: (row: OrderRow) => row.orderId,
        sortable: true,
      },
      {
        name: "Clinic",
        selector: (row: OrderRow) => row.clinic,
        sortable: true,
        cell: (row: OrderRow) => (
          <div
            title={row.clinic}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px"
            }}
          >
            {row.clinic}
          </div>
        )
      },

      {
        name: "Type",
        selector: (row: OrderRow) => row.type,
      },

      {
        name: "Status",
        cell: (row: OrderRow) => {
          const statusStyles: Record<string, { bg: string; color: string }> = {
            completed: { bg: "#d1fae5", color: "#065f46" },
            ready_for_delivery: { bg: "#dbeafe", color: "#1e40af" },
            pending_acceptance: { bg: "#fef3c7", color: "#92400e" },
            delay_report: { bg: "#fee2e2", color: "#991b1b" },
            pending: { bg: "#f3f4f6", color: "#374151" },
            out_for_delivery: { bg: "#3B82F6", color: "#fff" },
            delivered: { bg: "#22c55e", color: "#fff" },
            warranty_claimed: { bg: "#22c55e", color: "#fff" },
            cancelled: { bg: "#dc3545", color: "#fff" },
            cancellation_under_review: { bg: "#dc3545", color: "#fff" },
            under_review: { bg: "#FFCD39", color: "#fff" },
            "under_review(design)": { bg: "#FFCD39", color: "#fff" },
            "delay_report_(design)": { bg: "#b45309", color: "#fff" },
          };

          const status = (row.status || "")
            .toString()
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "_");

          const style = statusStyles[status] || {
            bg: "#f3f4f6",
            color: "#374151",
          };

          return (
            <span
              className="status-badge-report-order"
              style={{
                backgroundColor: style.bg,
                color: style.color,
              }}
            >
              {row.status || "-"}
            </span>
          );
        },
      }
    ],
    []
  );

  const exportExcel = () => {
    const exportData = filteredData.map((d) => ({
      "Order ID": d.orderId,
      "Clinic": d.clinic,
      "Type": d.type,
      "Status": d.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    XLSX.writeFile(workbook, "Dentist_Report.xlsx");
  };

  const exportPDF = () => {
    const doc = new jsPDF("landscape");

    const tableColumn = [
      "Order ID",
      "Clinic",
      "Type",
      "Status",
    ];

    const tableRows = filteredData.map((d) => [
      d.orderId,
      d.clinic,
      d.type,
      d.status,
    ]);

    doc.text("Dentist Order Report", 14, 15);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 25,
    });

    doc.save("Dentist_Report.pdf");
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {
      const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
      const [
        orderRes,
        typeRes,
      ] = await Promise.all([
        apiAxios.post(`${API_BASE}/Dentist/GetAllCasesDashBoard`, {
          clinicId: selectedClinic.clinicID
        }),
        apiAxios.get(`${API_BASE}/Central/order-type-dropdown`),
      ]);

      if (orderRes.data?.isSuccess) setOrderDropdown(orderRes.data.singleData);
      if (typeRes.data?.isSuccess) setOrderTypeDropdown(typeRes.data.data);

    } catch (err) {
      console.error("Dropdown error:", err);
    }
  };
  // const orderOptions = (orderDropdown || []).map(item => ({
  //   value: item.orderID.toString(),
  //   label: `${item.orderID} (Case ${item.caseID})`
  // }));
const orderOptions = useMemo(
  () =>
    [...(orderDropdown || [])]
      .sort(
        (a: any, b: any) =>
          new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
      )
      .map((item: any) => ({
        value: item.orderID.toString(),
        label: `${item.orderID} - ${new Date(item.createdDate).toLocaleDateString(
          "en-GB"
        )}`,
      })),
  [orderDropdown]
);
const typeOptions = (orderTypeDropdown || []).map((item: any) => ({
  value: item.orderTypeID.toString(),
  label: item.orderTypeName
}));
  return (
    <div className="container-fluid mt-4">
      {/* HEADER */}

      <div className="mb-4 report-design-heading">
        <h4 className="mb-4">Dentist Order Report</h4>
        <p className="text-muted mt-0 track-all-order">
          Track all orders and delivery status
        </p>
      </div>

      {/* SUMMARY CARDS */}

      <div className="order-status-bar mb-4">

        <div className="status-col">
          <h3>{totalOrders}</h3>
          <span className="status-badge bgnone">Total Orders</span>

        </div>



        <div className="status-col">
          <h3>{completedOrders}</h3>
          <div className="badge-box badge-success">
            <i className="bi bi-check-circle-fill completed-icon"></i>
            Completed
          </div>
        </div>

        <div className="status-col">


          <h3>{pendingOrders}</h3>
          <div className="status-badge warning">
            <i className="bi bi-clock-history"></i>
            Pending
          </div>
        </div>

        <div className="status-col">
          <h3>{cancelledOrders}</h3>

          <div
            className="status-badge"
            style={{
              background: "#dc3545",
              color: "#fff",
              borderRadius: "20px",
              padding: "6px 12px",
            }}
          >
            <i className="bi bi-x-circle-fill me-1"></i>
            Cancelled
          </div>
        </div>

      </div>

      {/* FILTER PANEL */}

      <div className="premium-card mb-4 p-3">

        <div className="row g-3">

          {/* Order ID */}
          <div className="col-md-4 col-lg-3">
            <Select
              options={orderOptions}
              value={orderOptions.find(o => o.value === filters.orderId) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, orderId: selected?.value || "" }))
              }
              placeholder="Select Order"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          {/* Order Type */}
          <div className="col-md-4 col-lg-3">
           <Select
  options={typeOptions}
  value={typeOptions.find(o => o.value === filters.type) || null}
  onChange={(selected) =>
    setFilters(prev => ({
      ...prev,
      type: selected?.value || ""
    }))
  }
  placeholder="Select Order Type"
  isClearable
  menuPortalTarget={document.body}
  styles={{
    menuPortal: base => ({
      ...base,
      zIndex: 9999
    })
  }}
/>
          </div>

          {/* Start Date */}
          <div className="col-md-4 col-lg-3 position-relative">
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              placeholderText="Select Start Date"
              className="form-control pe-5"
              dateFormat="dd-MM-yyyy"
              portalId="root"
            />
            <i className="bi bi-calendar3 calendar-icon"></i>
          </div>

          {/* End Date */}
          <div className="col-md-4 col-lg-3 position-relative">
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              placeholderText="Select End Date"
              className="form-control pe-5"
              dateFormat="dd-MM-yyyy"
              portalId="root2"
            />
            <i className="bi bi-calendar3 calendar-icon"></i>
          </div>

          {/* Global Search */}
          <div className="col-md-6 col-lg-3">
            <input
              className="form-control"
              placeholder="Global Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Buttons */}
          <div className="col-md-6 col-lg-4 d-flex align-items-end gap-2">

            <button type="button" className="btn btn-primary px-4" onClick={fetchReport}>
              Search
            </button>

            <button
              className="btn btn-secondary   d-flex align-items-center"
              onClick={handleClear}
            >
              Clear
            </button>

          </div>

        </div>
      </div>



      {/* TABLE */}

      <div className="premium-card p-4 round">
        <div className="d-flex justify-content-end gap-2 mb-3">

          <button
            className="btn btn-success"
            onClick={exportExcel}
            disabled={filteredData.length === 0}
          >
            <i className="bi bi-file-earmark-excel me-2"></i>
            Export Excel
          </button>

          <button
            className="btn btn-danger"
            onClick={exportPDF}
            disabled={filteredData.length === 0}
          >
            <i className="bi bi-file-earmark-pdf me-2"></i>
            Export PDF
          </button>

        </div>
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          striped
          responsive
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />
      </div>
    </div>
  );
};

export default DentistReport;